import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Magnetic from "@/components/shared/Magnetic";

export default function ForCreatorsBand() {
  return (
    <section
      data-testid="home-for-creators"
      className="relative py-10 md:py-14 border-t border-white/5 bg-black overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-white/[0.035] blur-3xl pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <div className="text-xs uppercase tracking-[0.24em] text-zinc-500 mb-4">
              For creators
            </div>
            <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl tracking-tight text-balance">
              Get paid to post the music
              <span className="italic font-light"> you already love.</span>
            </h2>
            <p className="mt-4 max-w-xl text-zinc-400 leading-relaxed">
              2,000+ creators run campaigns with us across TikTok, Reels, and
              Shorts. Direct rates, weekly pay, no middlemen.
            </p>
          </div>

          <div className="lg:col-span-4 flex flex-col md:flex-row lg:flex-col gap-3 lg:items-end">
            <Magnetic radius={140} strength={0.4}>
              <Link
                to="/become-a-creator"
                data-testid="home-become-creator-cta"
                className="inline-flex items-center gap-2 bg-white text-black font-semibold rounded-full px-6 py-3.5 hover:bg-zinc-200 btn-magnetic glow-cta"
              >
                Apply to the roster <ArrowUpRight size={18} />
              </Link>
            </Magnetic>
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500">
              2-minute application
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
